function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { strictSpace } from '../../utils';
import styledPropTypes from '@styled-system/prop-types';

var variantToBgColor = function variantToBgColor(variant, theme) {
  var map = {
    success: theme.colors.bgPositiveSecondary,
    warning: theme.colors.bgWarningSecondary,
    error: theme.colors.bgNegativeSecondary
  };
  return map[variant] || theme.colors.bgActionSecondary;
};

var variantToTextColor = function variantToTextColor(variant, theme) {
  var map = {
    success: theme.colors.textPositiveSecondary,
    warning: theme.colors.textWarningSecondary,
    error: theme.colors.textNegativeSecondary
  };
  return map[variant] || theme.colors.textPrimary;
};
/**
 * Renders an alert for displaying messages.
 */


var Alert = styled.div.withConfig({
  displayName: "Alert",
  componentId: "sc-weitv9-0"
})(["color:", ";", ";border-radius:", ";box-shadow:", ";background-color:", ";", " img{vertical-align:middle;}"], function (_ref) {
  var variant = _ref.variant,
      theme = _ref.theme;
  return variantToTextColor(variant, theme);
}, function (_ref2) {
  var textAlign = _ref2.textAlign;
  return textAlign && "text-align: ".concat(textAlign);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius.radius8;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shadows.one;
}, function (_ref5) {
  var variant = _ref5.variant,
      theme = _ref5.theme;
  return variantToBgColor(variant, theme);
}, strictSpace);
Alert.defaultProps = {
  p: 's',
  mb: 'xs'
};
Alert.displayName = 'Alert';
Alert.propTypes = _objectSpread({
  textAlign: PropTypes.oneOf(['left', 'center', 'right']),
  variant: PropTypes.oneOf(['success', 'error', 'warning'])
}, styledPropTypes.space);
/** @component */

export default Alert;